import { render, staticRenderFns } from "./CotacaoAbertaComponent.vue?vue&type=template&id=71d82216&scoped=true"
import script from "./CotacaoAbertaComponent.vue?vue&type=script&lang=js"
export * from "./CotacaoAbertaComponent.vue?vue&type=script&lang=js"
import style0 from "./CotacaoAbertaComponent.vue?vue&type=style&index=0&id=71d82216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d82216",
  null
  
)

export default component.exports